import { GesEvalType } from '../../../../types';
export var list = [
    GesEvalType.MAIL,
    GesEvalType.ONLINE,
];
